import EA from '../helpers/init';
import gsap from 'gsap';
import SplitText from '../plugins/SplitText';


export default EA.Methods.animColorFill = ($this) => {
    gsap.registerPlugin(SplitText);

    const originalcolor = getComputedStyle($this).color;
    const wantedColor = $this.getAttribute('data-color');
    let split = null;

    let charAnims = null;
    
    addEventListener('resize', () => {
        if(charAnims) {
            split.revert();
            charAnims = null;
            $this.style.color = wantedColor;
        }
    });
    
    document.fonts.ready.then(function () {
        split = new SplitText($this, { type: 'chars,words' });
        
        gsap.set(split.chars, {
            color: originalcolor,
        });

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: $this,
                scrub: false,
                stagger: 1,
                start: '-100px center'
            }
        });

        tl.to(split.chars, {
            duration: 0.3, 
            color: wantedColor,
            stagger: 0.03,
        });

        charAnims = [];
        charAnims.push(split.chars);
    });

};
